import {
    LOCATION_CHANGED,
    PUSH,
    GO_BACK,
    GO,
    REPLACE,
    push,
    go,
    goBack,
    replace
} from 'redux-little-router';

const ACTIONS = {
    NAVIGATE: 'ROUTER/NAVIGATE',
    LOCATION_CHANGED,
    PUSH,
    GO_BACK,
    GO,
    REPLACE
};

const ACTION_CREATORS = {
    navigate(updatedParams, options = {}) {
        /* istanbul ignore next */
        return {
            type: ACTIONS.NAVIGATE,
            payload: {updatedParams, options}
        };
    },
    routerPush: push,
    routerReplace: replace,
    navigateTo: push,
    navigateToModal(modalRoute, type = 'push') {
        return {
            type: ACTIONS.NAVIGATE,
            payload: {
                updatedParams: {
                    r: modalRoute
                },
                options: {
                    persist: true,
                    type
                }
            }
        };
    },
    navigateBackTo() {
        // Limit how often this action can fire. See the limiterMiddleware
        // for more details.
        return {
            ...goBack(),
            meta: {
                limit: 1500
            }
        };
    },
    go
};

export default {...ACTIONS, ...ACTION_CREATORS};
